import LicensePricing from './licensepricing'

export default LicensePricing
